import { Link } from "react-router-dom";

const highlights = [
  {
    icon: "ri-movie-2-line",
    title: "海量动画资源库",
    text: "收录冒险、科幻、恋爱、热血等八大分类，按年份、评分与热度自由筛选，快速定位想看的那一部。",
  },
  {
    icon: "ri-user-heart-line",
    title: "完整角色资料",
    text: "为每部作品整理主要角色档案，包含性格、故事线与人物关系，帮助你在观看前就理解角色。",
  },
  {
    icon: "ri-newspaper-line",
    title: "每日行业资讯",
    text: "追踪定档消息、制作访谈与行业观察，第一时间掌握日本动画圈的最新动态。",
  },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
        <div className="lg:col-span-5">
          <span className="inline-flex items-center gap-1.5 text-xs font-label font-semibold uppercase tracking-wider text-primary-600">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
            About Riman
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-extrabold text-foreground-950 leading-tight">
            一个为动漫爱好者打造的
            <br className="hidden md:block" />
            日本动画探索门户
          </h2>
          <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600">
            「日漫」专注于日本动画资源整理与行业资讯传播。我们相信，好作品值得被清楚地介绍——从剧情梗概到角色关系，从播出信息到幕后故事，帮你在一部动画开始之前就找到心动的理由。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center gap-2 px-5 h-11 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看最新资讯
            </Link>
          </div>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {highlights.map((item, index) => (
            <div
              key={item.title}
              className={`p-5 rounded-lg border border-background-200 ${
                index === 1 ? "bg-secondary-50" : "bg-background-100"
              }`}
            >
              <span className="w-11 h-11 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}